export default "__VITE_ASSET__CsCdw7kE__"